export default __webpack_public_path__ + "static/media/problema-03.edf843ff.webp";